export type CsvDelimiter = ';' | ',' | '\t'

export interface ParsedCsv {
  rows: string[][]
  delimiter: CsvDelimiter
}

export function detectDelimiter(text: string): CsvDelimiter {
  const candidates: CsvDelimiter[] = [';', ',', '\t']
  const sample = text.slice(0, 20_000)
  let best: { delimiter: CsvDelimiter; score: number } = { delimiter: ';', score: -1 }

  for (const delimiter of candidates) {
    const counts: number[] = []
    let count = 0
    let quoted = false

    for (let index = 0; index < sample.length && counts.length < 8; index += 1) {
      const char = sample[index]
      if (char === '"') {
        if (quoted && sample[index + 1] === '"') index += 1
        else quoted = !quoted
      } else if (!quoted && char === delimiter) {
        count += 1
      } else if (!quoted && (char === '\n' || char === '\r')) {
        if (char === '\r' && sample[index + 1] === '\n') index += 1
        if (count > 0) counts.push(count)
        count = 0
      }
    }

    const score = counts.length
      ? counts.reduce((sum, value) => sum + value, 0) / counts.length
      : 0
    if (score > best.score) best = { delimiter, score }
  }

  return best.delimiter
}

export function parseCsvText(input: string): ParsedCsv {
  const text = String(input).replace(/^\uFEFF/, '')
  const delimiter = detectDelimiter(text)
  const rows: string[][] = []
  let row: string[] = []
  let field = ''
  let quoted = false

  for (let index = 0; index < text.length; index += 1) {
    const char = text[index]
    if (quoted) {
      if (char === '"') {
        if (text[index + 1] === '"') {
          field += '"'
          index += 1
        } else {
          quoted = false
        }
      } else {
        field += char
      }
      continue
    }

    if (char === '"') quoted = true
    else if (char === delimiter) {
      row.push(field)
      field = ''
    } else if (char === '\n' || char === '\r') {
      if (char === '\r' && text[index + 1] === '\n') index += 1
      row.push(field)
      field = ''
      rows.push(row)
      row = []
    } else {
      field += char
    }
  }

  if (field !== '' || row.length) {
    row.push(field)
    rows.push(row)
  }

  return { rows, delimiter }
}
